import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import MediaCategoryListLayer from "../components/MediaCategoryListLayer";

const MediaCategoryListPage = () => {
    return (
        <MasterLayout>
            <MediaCategoryListLayer />
        </MasterLayout>
    );
};

export default MediaCategoryListPage;
